module.exports = __webpack_public_path__ + "static/media/mobile-adb.c13cba12.jpg";